/*******************************************************************************************************************************************************
Usare la sidebar:
1 - Il componente che ne richiede l'utilizzo chiama this.$root.$emit("toggleFileSystemSidebar", selectedNodes, config), dove :
    - selectedNodes : è l'array di nodi che verrà modificato con la selezione e de-selezione delle checkbox. Può essere vuoto o contenere degli oggetti;
    - config : è un oggetto che contiene e seguenti campi :
        - type : il tipo (numero intero) del service account/piattaforma a cui faranno riferimento le risorse;
        - includeFiles: boolean che specifica se si vuole caricare anche i file o meno.
        E' false, ad esempio, durante la scelta delle destinationi o del path per un repository;
        - limit: il numero che indica quanti elementi può selezionare l'utente. se è 0, l'utente non ha limiti;
        - client: oggetto, che può essere null in determinate situazioni, che consente di richiedere le risorse.
        Nel caso sia null, verranno utilizzate delle chiamate socket per richiedere le risorse.
        - rootPath : il percorso da cui l'albero del filesystem deve partire.
        Nel caso sia null, verranno richieste le root

    Dopo la chiamata this.$root.$emit("toggleFileSystemSidebar", selectedNodes, config),
    - la sidebar, inizialmente chiusa, verrà aperta
    - se necessario, verrà popolata la selezione roots per scegliere la cartella di partenza per richiedere file e cartelle,
    altrimenti verranno richiesti file e cartelle della root della piattaforma corrispondente a type;
    - verrà resettato l'intero treeview.
2 - Per aprire o chiudere la sidebar, un componente può utilizzare le chiamate :
    - this.$root.$emit("toggleFileSystemSidebar", selectedNodes, config) per aprire o chiudere la sidebar;
    - this.$root.$emit("closeFileSystemSidebar") per chiudere la sidebar.
3 - Al click di una checkbox, il nodo corrispondente a tale checkbox verrà aggiunto/rimosso (d)all'array selectedNodes.
4 - Al click di una cartella, verranno richieste le risorse figlie di questa cartella, utilizzando i dati specificati in config
*******************************************************************************************************************************************************/

import { ERROR } from '../utils/messages';


import { isValid, getNodeType, getRootType, assignProperties, waitSeconds, getValueOrDefault } from '../utils/utilitiesmodule';
import { ClientTreeNode } from '../models/TreeNode';
import $ from 'jquery'
import { disconnectServiceAccount } from '../utils/entityMethods/serviceAccount';

export default {
    name: "FileSystemSidebar",
    data: function () {
        return {

            //FILESYSTEM
            //roots: [], //la lista di nodi che rappresentano le cartelle principali

            tree: new ClientTreeNode("node", "", "", this.$FileFolderEntityType.FN_Folder), //null, // { path: "" },
            clickedNode: null,

            loading: false,

            selectedNodes: null,
            config: {
                type: 0,
                includeFiles: true,
                limit: 0,
                client: null,
                //rootFolder: ""
            },

            filters: {
                pathToSearch: "",
                extensions: "",
                includeSpecifiedExtensions: true
            },

            //Si riferisce alla classe ExploreFSOptions dell'agent
            exploreFSOptions: {
                includeFiles: true,
                includeHiddenFiles: false,
                includeInaccessibleFiles: false,
                includeSystemFiles: false,
                includeDetails: false
            },

            title: ""

        }
    },
    beforeDestroy: function () {
        this.$root.$off("toggleFileSystemSidebar");
        this.$root.$off("closeFileSystemSidebar");
        this.$root.$off("uncheckNode");
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        if (this.config.client != null) {
            this.disconnectServiceAccount(this.config.client.serviceAccount);
        }
    },
    mounted() {
        //let self=this;
        this.setTreeviewCallbacks();

        this.$root.$on("toggleFileSystemSidebar", (selectedNodes, config) => this.toggleFileSystemSidebar(selectedNodes, config));
        this.$root.$on("closeFileSystemSidebar", () => this.closeFileSystemSidebar());

        this.$root.$on('uncheckNode', (node) => {

            var nodeToUncheck = $("#checkbox-" + node.nodeID)[0];
            if (nodeToUncheck != undefined) {
                nodeToUncheck.click()
            }
        });

        //Non utilizzato ma può essere utile in futuro
        this.$root.$on("fileSystemSidebar_selectAll", selectAll => {
            var htmlNode;
            this.tree.children.forEach(n => {
                htmlNode = $("#checkbox-" + n.nodeID)[0];
                if (htmlNode == undefined || htmlNode.checked == selectAll) {
                    return;
                }

                htmlNode.click()

            });
        });

    },
    computed: {
        isOpen: function () { return Metro.charms.isOpen("#fileSystemSidebar"); }
    },

    methods: {
        disconnectServiceAccount,
        /***********************************APERTURA/CHIUSURA DELLA SIDEBAR*********************************************************************/
        toggleFileSystemSidebar(selectedNodes, config) {
            this.setTreeviewCallbacks();
            if (window.Metro.charms.isOpen("#fileSystemSidebar") && isValid(this.config) && config.type == this.config.type)
                return;

            if (window.Metro.charms.isOpen("#fileSystemSidebar"))
                this.closeFileSystemSidebar();
            else
                this.openFileSystemSidebar(selectedNodes, config);
        },

        openFileSystemSidebar(selectedNodes, config) {
            if (!window.Metro.charms.isOpen("#fileSystemSidebar")) {
                window.Metro.charms.open("#fileSystemSidebar");
                this.setSidebar(selectedNodes, config);
            }
        },

        closeFileSystemSidebar() {
            if (window.Metro.charms.isOpen("#fileSystemSidebar")) {
                //this.$root.$emit("sendSelectedNodes", this.selectedNodes);
                window.Metro.charms.close("#fileSystemSidebar");
                this.loading = false;
            }
        },

        /*
            Questo metodo viene chiamato :
            - Quando viene aperta la sidebar (isValid(config)),
            - Quando si cambia la root
        */
        async setSidebar(selectedNodes, config) {
            if (this.loading) return;

            this.loading = true;

            if (config.limit == 0) {
                this.title = this.$t('Select one or more items');
            } else if (config.type == this.$ONEServiceType.Microsoft_Teams) {
                this.title = this.$t('Select up to {0} teams and up to {0} users', { 0: config.limit });
            }
            else if (config.limit == 1) {
                this.title = this.$t('Select a path');
            } else {
                this.title = this.$t("Select up to {0} items", { 0: config.limit });
            }

            //1 - Si svuota la treeview
            var treeview = window.Metro.getPlugin("#treeview", "treeview");
            if (isValid($('#node')) && isValid(treeview)) {
                treeview.clean($('#node'));
                assignProperties(new ClientTreeNode("node", "", "" /*ONEServiceTypeInfo[config.type].name*/, getRootType(config.type)), this.tree);
                var firstCheck = $("#checkbox-node")[0];
                if (isValid(firstCheck)) {
                    firstCheck.checked = false;
                    firstCheck.dataset.indeterminate = false;
                    this.clickedNode = null;
                }
            }


            if (!isValid(config)) {
                console.writeError("config è null!!!");
                await this.getNSetChildrenOfPath(this.tree.path, false);
                return;
            }
            // 1 - Si memorizzano i dati passati

            this._setConfig(config);
            this.selectedNodes = selectedNodes;

            // 2 - Si cambia la root
            if (isValid(this.config.tree)) {
                this.tree.nodeID = this.config.tree.nodeID;
                this.tree.resID = this.config.tree.resID;
                this.tree.path = this.config.tree.path;
                this.tree.type = this.config.tree.type; // FileFolderEntityType: ...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Core\Utils\Enums.cs
                this.tree.nParts = this.config.tree.nParts;
                this.tree.children.update(this.config.tree.children);
                this.tree.visible = true;

                this.setChildrenToViewNode("node", this.tree.children, true);
                this.loading = false;
                return;
            }

            if (this.config.rootPath != null && typeof this.config.rootPath == "string") {
                this.tree.nodeID = "node";
                this.tree.resID = null;
                this.tree.path = this.config.rootPath;
                this.tree.type = getNodeType(this.config.type, false); // FileFolderEntityType: ...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Core\Utils\Enums.cs
                var slash = this.tree.path.getSeparator();
                this.tree.nParts = this.tree.path.split(slash).length;
                this.tree.children.clear();
                this.tree.visible = true;
            }

            if (this.config.rootPath != null && typeof this.config.rootPath != "string") {
                this.tree.nodeID = "node";
                this.tree.resID = null;
                this.tree.path = this.config.rootPath.path;
                this.tree.type = this.config.rootPath.type; // FileFolderEntityType: ...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Core\Utils\Enums.cs
                var slash = this.tree.path.getSeparator();
                this.tree.nParts = this.tree.path.split(slash).length;
                this.tree.children.clear();
                this.tree.visible = true;
            }


            //     this.tree = null;
            // else
            //     this.tree = new ClientTreeNode(
            //         "node",
            //         null,
            //         this.config.rootPath,
            //         getNodeType(this.config.type, false)
            //     );

            // 3- Si richiedono i dati per popolare la sidebar
            await this.getNSetChildrenOfPath(this.config.rootPath, false);
        },
        /******************************************************************CHILDREN****************************************************************************/

        async getNSetChildrenOfPath(path, searchInTree) {

            this.loading = true;

            var getFirstChildren = !isValid(path);

            //Step 1 : Impostazione del nodo selezionato e del tree (se non precedentemente impostato).
            this._setTreeAndClickedNode(path);

            //Step 2 : Se è stato specificato, controllo nell'albero se sono già stati richiesti i children di path.
            //In caso affermativo, termino la ricerca
            if (isValid(path) && searchInTree && this.clickedNode.children.length > 0) {
                this.loading = false;
                return;
            }

            var requestData;
            var children;

            try {

                // Step 3 : A seconda del tipo della piattaforma da cui devo prendere file e cartelle, eseguo una chiamata differente
                switch (this.config.type) {
                    // Caso 1 : CLOUD
                    case this.$ONEServiceType.Cloud_S3CompatibleStorage:
                    case this.$ONEServiceType.Cloud_IperiusS3Storage:
                    case this.$ONEServiceType.Cloud_AmazonS3Storage:
                    case this.$ONEServiceType.Cloud_AzureBlob:
                    case this.$ONEServiceType.Cloud_AzureFile:
                    case this.$ONEServiceType.Cloud_Dropbox:
                    case this.$ONEServiceType.Cloud_GoogleDrive:
                        if (getFirstChildren)
                            children = await this.config.client.getRootNodes();
                        else
                            children = await this.config.client.getNodesFrom(this.clickedNode);
                        break;
                    //Caso 1.1 : OneDrive    
                    case this.$ONEServiceType.Cloud_OneDrive:
                        if (getFirstChildren)
                            children = await this.config.client.getOneDriveRootNodes();
                        else
                            children = await this.config.client.getOneDriveNodesFrom(this.clickedNode);
                        break;

                    // Caso 2 : FTP
                    case this.$ONEServiceType.FTP:
                        requestData = {
                            accountSessionId: this.config.client.serviceAccount.options.accountSessionId,
                            nodeID: this.clickedNode.nodeID,
                            path: path ?? "", //percorso da esplorare,
                            options: this.exploreFSOptions //vedi ExploreFSOptions,
                        };

                        children = await this.$root.socket("exploreftp", requestData);
                        break;
                    // Caso 3 : FileFolder
                    case this.$ONEServiceType.FileFolder:
                        requestData = {
                            nodeID: this.clickedNode.nodeID,
                            path: path, //percorso da esplorare,
                            options: this.exploreFSOptions //vedi ExploreFSOptions,
                        };
                        var fs = await this.$root.socket("GetExploreFs", requestData);
                        if (fs == null) {
                            children = null;
                            break
                        }

                        if (getFirstChildren)
                            children = fs.drives.map((d) => new ClientTreeNode(
                                null,
                                null,
                                d,
                                this.$FileFolderEntityType.FN_Folder
                            ));
                        else
                            children = fs.items;

                        break;
                    case this.$ONEServiceType.Network: //Network
                        requestData = {
                            accountSessionId: this.config.client.serviceAccount.options.accountSessionId,
                            nodeID: this.clickedNode.nodeID,
                            path: path, //percorso da esplorare,
                            options: this.exploreFSOptions //vedi ExploreFSOptions,
                        };
                        //Ritorna la lista di ClientTreeNode
                        children = await this.$root.socket("getexplorenetworkfs", requestData);
                        break;

                    case this.$ONEServiceType.Microsoft_OneDriveForBusiness:
                    case this.$ONEServiceType.Microsoft_SharePoint:
                        var m365Tree = await this.$root.socket("GetMicrosoft365List", this.config.client.serviceAccount, this.config.type, null);
                        if (m365Tree == null) {
                            this.loading = false;
                            return;
                        }
                        children = m365Tree.children;
                        this.tree.resID = m365Tree.resID;
                        this.tree.path = m365Tree.path;
                        this.tree.type = m365Tree.type;
                        //provo a non ritrasformarli in oggetti
                        //children = children.map(n => new ClientTreeNode(n.nodeID, n.resID, n.path, n.type));
                        this.setChildrenToLogicNode("node", children);
                        this.setChildrenToViewNode("node", children, false);
                        this.loading = false;
                        return;
                    //children = await this.config.client.getSites();

                    case this.$ONEServiceType.Microsoft_Teams: //Teams

                        if (!getFirstChildren) {
                            children = await this.$root.socket("GetMicrosoft365List", this.config.client.serviceAccount, this.config.type, this.clickedNode.resID);
                            if (children != null)
                                children = children.map(n => new ClientTreeNode(n.nodeID, n.resID, n.path, n.type));
                            //children = await this.config.client.getChannelsByTeamID(this.clickedNode.resID, this.clickedNode.path);
                            break;
                        }

                        var m365Tree = await this.$root.socket("GetMicrosoft365List", this.config.client.serviceAccount, this.config.type, null);

                        if (m365Tree == null) {
                            this.loading = false;
                            return;
                        }

                        /* mTeamsObject.teams = mTeamsObject.teams.map(n => new ClientTreeNode(n.nodeID, n.resID, n.path, n.type));
                        mTeamsObject.users = mTeamsObject.users.map(n => new ClientTreeNode(n.nodeID, n.resID, n.path, n.type));
                        //Creo 2 sottonodi. uno ospiterà i team e l'altro gli utenti
                        var teamsNode = new ClientTreeNode("node-0", "ALLTEAMS", "Teams", FileFolderEntityType.MT_Team_AllTeams);
                        var usersNode = new ClientTreeNode("node-1", "ALLUSERS", "Users", FileFolderEntityType.CloudAccount_All); */
                        children = m365Tree.children;
                        this.tree.resID = m365Tree.resID;
                        this.tree.path = m365Tree.path;
                        this.tree.type = m365Tree.type;
                        //Creo i due nodi sotto la root
                        this.setChildrenToLogicNode("node", children);
                        this.setChildrenToViewNode("node", children, false);


                        this.setChildrenToLogicNode("node-0", children[0].children);
                        this.setChildrenToViewNode("node-0", children[0].children, false);
                        this.setChildrenToLogicNode("node-1", children[1].children);
                        this.setChildrenToViewNode("node-1", children[1].children, false);
                        this.loading = false;
                        return;

                }

                if (children == null) {
                    this.loading = false;
                    return;
                }

                //Step 4 : Assegno l'id ai nodi
                children = children.map((c, i) => {
                    if (c.nodeID == null)
                        c.nodeID = this.clickedNode.nodeID + "-" + i;
                    if (typeof c != "ClientTreeNode") {
                        c = new ClientTreeNode(c.nodeID, c.resID, c.path, c.type);
                    }
                    return c;
                });

                //Step 5 : Assegno i children al nodo selezionato
                this.setChildrenToLogicNode(this.clickedNode.nodeID, children);

                this.setChildrenToViewNode(this.clickedNode.nodeID, children, false);

                this.loading = false;

            } catch (e) {
                this.$root.toast(this.$t(ERROR), "alert");
                console.writeError(e);
            } finally {
                this.$root.$emit("endListingFromFileSystemSidebar");
                this.loading = false;

            }
        },

        setChildrenToLogicNode(id, children) {
            var currentNode = this.tree.findNodeWithId(id);
            currentNode.children = children.map(child => {
                if (typeof child != "ClientTreeNode") {
                    child = new ClientTreeNode(child.nodeID, child.resID, child.path, child.type);
                }
                return child;
            });
            return currentNode;
        },

        setChildrenToViewNode(id, children, recursive, clear = true) {

            var treeview = window.Metro.getPlugin("#treeview", "treeview");

            //Step 1a : Toglie l'eventuale nodo finto aggiunto nello step 2.3
            if (clear)
                $("#" + id + " ul").remove();

            //this.sleep(1000);
            var isChecked;
            //Step 2 : Per ogni nuovo child da aggiungere
            children.forEach(child => {

                if (!this.config.includeFiles && child.type.isFile())
                    return;

                isChecked = this.selectedNodes.length != 0 && (
                    //bisogna selezionare il figlio se è stato selezionato un genitore o un parent
                    this.selectedNodes.findIndex(n => child.nodeID == n.nodeID || child.nodeID.startsWith(n.nodeID + "-")) != -1 ||
                    this.selectedNodes.findIndex(n =>
                        child.path == n.path ||
                        child.path.startsWith(n.path + "/") ||
                        child.path.startsWith(n.path + "\\")
                    ) != -1

                    //bisogna selezionare il figlio se è presente nella lista dei nodi
                    //this.selectedNodes.findIndex(n => child.nodeID == n.nodeID) != -1
                );

                if (typeof child != "ClientTreeNode")
                    child = new ClientTreeNode(child.nodeID, child.resID, child.path, child.type);
                //Step 2.1 : Aggiungo una checkbox all'interno del nodo
                //Questo comando crea, dentro il nodo, la struttura 
                //ul(solo alla prima chiamata di addTo) -> li -> template
                treeview.addTo(
                    id == 'treeview' ?
                        null :
                        $("#" + id), {
                        html: this.config.limit == 1 
                        ? child.getTemplateForSingleChoice(isChecked) 
                        : child.getTemplate(isChecked)
                    }
                );




                //Step 2.2 : Aggiungo gli attributi al li
                $("#" + id + " li").last().attr({
                    "id": child.nodeID,
                    "path": child.path,
                    "class": child.type.expandChildren() ? 'tree-node expanded' : ''
                });

                /*
                <li id="nodeID" ...>
                <a>
                <label>
                */
                var aTag_in_li = $("#" + child.nodeID + " a");
                if (aTag_in_li && aTag_in_li.length > 0) {
                    aTag_in_li = aTag_in_li[0];
                    var labelTag_in_a = aTag_in_li.firstChild;

                    if (labelTag_in_a) {
                        // Move cElement to the parent of bElement (which is a)
                        aTag_in_li.parentNode.insertBefore(labelTag_in_a, aTag_in_li);

                        // Remove bElement
                        aTag_in_li.remove();
                    }

                }
                /**/

                //Step 2.3 : In seguenti elementi possono contentere figli sull'interfaccia
                switch (child.type) {
                    case this.$FileFolderEntityType.FN_Folder:
                    case this.$FileFolderEntityType.Cloud_Root:
                    case this.$FileFolderEntityType.Cloud_Bucket:
                    case this.$FileFolderEntityType.Cloud_Folder:
                    case this.$FileFolderEntityType.SP_Site_All:
                    case this.$FileFolderEntityType.MT_Team_All:
                    case this.$FileFolderEntityType.MT_Team:
                    case this.$FileFolderEntityType.FTP_Folder:
                        //Step 2.3.1: Aggiungo un finto elemento all'interno della cartella, per far apparire la freccetta per il toggle.
                        //Quando il nodo verrà riempito, chiamando "treeview.clean(htmlNode)", verrà cancellato il finto elemento
                        treeview.addTo(
                            $("#" + child.nodeID), {
                            html: "<ul><li></li></ul>"
                        }
                        )

                        //Step 2.3.2 : Chiudo il nodo
                        /*if (child.visible)*/
                        treeview.toggleNode($("#" + child.nodeID));
                }

                if (recursive && isValid(child.children) && child.children.length > 0)
                    this.setChildrenToViewNode(child.nodeID, child.children, true);

                //if (this.selectedNodes.findIndex(n => child.nodeID==n.nodeID)!=-1)
                //    $("#checkbox-"+child.nodeID)[0].click();
            });
        },

        /*************************************FUNZIONI PER LE CHECKBOX***********************************************/
        setNode(node, checked) {
            this.clickedNode = node;
            if (checked && this.selectedNodes.findIndex(n => n.nodeID == node.nodeID) != -1) {
                return;
            }

            //Snapshot della selezione corrente: serve per fare rollback se la nuova
            //selezione supera config.limit
            var previousSelection = [...this.selectedNodes];

            var otherNodes = [];
            if (this.selectedNodes.length != 0) {
                otherNodes = this.selectedNodes.filter(n => !n.path.startsWith(node.path.getParent()));
            }

            this.selectedNodes.clear();

            if (this.config.limit == 1 && checked) {
                this.selectedNodes.push(node);
                this.$root.$emit("sendSelectedNodes", this.selectedNodes);
                return;
            }

            var allInput_selected = this.config.limit != 1 ?
                $("#treeview input[type=checkbox]") :
                $("#treeview input[type=radio]");

            var input, nodeID, currentNode;
            for (var i = 0; i < allInput_selected.length; i++) {
                input = allInput_selected[i];
                if (!input.checked || input.indeterminate) {
                    continue;
                }
                nodeID = input.id.replace("checkbox-", "");
                currentNode = this.tree.findNodeWithId(nodeID)
                if (this.selectedNodes.length == 0) {
                    this.selectedNodes.push(currentNode);
                    continue;
                }


                if (
                    //se nei nodi selezionati è già presente currentNode
                    this.selectedNodes.some(n => currentNode.nodeID == n.nodeID) ||
                    //se nei nodi selezionati è già presente il padre di currentNode
                    this.selectedNodes.some(n => currentNode.nodeID.startsWith(n.nodeID + "-"))
                ) {
                    continue;
                }


                this.selectedNodes.push(currentNode);
            }

            if (otherNodes.length != 0) {
                this.selectedNodes.push(...otherNodes/*selectedNodes.filter*/);
                this.selectedNodes.update(this.selectedNodes.distinctBy("path"));
            }

            if (checked &&
                this.config.type.isMicrosoft365() &&
                this.config.limit > 0 &&
                this.selectedNodes.length > this.config.limit
            ) {
                var message = this.applyMicrosoft365Limit();
                if (message) {
                    this.selectedNodes.update(previousSelection);
                    //Deseleziono la checkbox appena cliccata (usando .click() per coerenza
                    //con lo stato interno di Metro UI, come fa il listener 'uncheckNode')
                    var justChecked = $("#checkbox-" + node.nodeID)[0];
                    if (justChecked != undefined) {
                        justChecked.click();
                    }

                    this.$root.toast(
                        this.$t(message, { 0: this.config.limit }),
                        "warning"
                    );
                    return;
                }
            }

            this.selectedNodes.sort((a, b) => a.nodeID <= b.nodeID ? 1 : -1);

            this.$root.$emit("sendSelectedNodes", this.selectedNodes);

        },

        applyMicrosoft365Limit() {

            //Controllo del limite: se l'utente sta aggiungendo un nodo e la nuova
            //selezione supera config.limit, annulla l'operazione e ripristina lo stato
            //precedente. config.limit == 0 significa nessun limite.

            //Per gli altri valori di config.type il limite vale sul totale di selectedNodes.
            switch (this.config.type) {

                //Per Microsoft Teams il limite si applica separatamente a due categorie:
                //- max config.limit nodi MT_Team (i Team)
                //- max config.limit nodi CloudAccount (gli utenti)
                //I nodi MT_Channel (canali) e gli altri tipi non rientrano nel conteggio.                
                case this.$ONEServiceType.Microsoft_Teams:
                    var teamCount = this.selectedNodes.filter(n => n.type == this.$FileFolderEntityType.MT_Team).length;
                    if (teamCount > this.config.limit) {
                        return "Your licence allows you to select only {0} teams";
                    }

                    var userCount = this.selectedNodes.filter(n => n.type == this.$FileFolderEntityType.CloudAccount).length;
                    if (userCount > this.config.limit) {
                        return "Your licence allows you to select only {0} users";
                    }

                    return null;

                case this.$ONEServiceType.Microsoft_SharePoint:
                    return "Your licence allows you to select only {0} sites";

                case this.$ONEServiceType.Microsoft_OneDriveForBusiness:
                    return "Your licence allows you to select only {0} accounts";

                case this.$ONEServiceType.Microsoft_Exchange365:
                    return "Your licence allows you to select only {0} mailboxes";
            }
            return null;
        },

        /************************UTILS******************************************************/
        sleep(ms) {
            return new Promise((resolve) => {
                setTimeout(resolve, ms);
            });
        },
        setTreeviewCallbacks() {
            let self = this;
            var treeview = window.Metro.get$el("#treeview").data("treeview");
            if (treeview == undefined)
                return;
            treeview = treeview.options;
            treeview.onExpandNode = (htmlNode, tree) => self.onExpandNode(htmlNode, tree);
            treeview.onCollapseNode = (htmlNode, tree) => self.onCollapseNode(htmlNode, tree);
            treeview.onCheckClick = (state, _, htmlNode) => self.onCheckClick(state, htmlNode); // check e tree non mi servono ma se non le uso il compilatore si lamenta
            treeview.onRadioClick = (state, _, htmlNode) => self.onRadioClick(state, htmlNode); // check e tree non mi servono ma se non le uso il compilatore si lamenta
        },

        /**********************CALLBACK*********************************/
        onExpandNode(htmlNode) {
            var nodePath = htmlNode.attributes.path.nodeValue;
            this.getNSetChildrenOfPath(nodePath, true);
        },
        onCollapseNode(htmlNode) {
            var node = this.tree.findNodeWithId(htmlNode.id);
            if (node) node.visible = false;
        },
        async onCheckClick(state, htmlNode) { // state ==true se è stato checkato, false viceversa
            await waitSeconds(0.1);
            this.setNode(this.tree.findNodeWithId(htmlNode.id), state);
        },
        async onRadioClick(state, htmlNode) { // state ==true se è stato checkato, false viceversa
            await waitSeconds(0.1);
            this.setNode(this.tree.findNodeWithId(htmlNode.id), state);
        },

        onClearSearch() {
            this.config.rootPath = null;
            this.setSidebar(this.selectedNodes, this.config);
        },

        //Imposta tree e clickedNode
        _setTreeAndClickedNode(path) {
            //Caso 1 : Se è stato specificato un path e il tree non è ancora stato impostato
            //l'albero parte dal path passato e path sarà il nodo selezionato
            if (isValid(path) && this.tree.path == "" && this.tree.children.length == 0) {
                this.clickedNode = this.tree.findNodeWithPath(path);
                if (!isValid(this.clickedNode)) {
                    assignProperties(new ClientTreeNode("node", "", path, getRootType(this.config.type)), this.tree);
                    this.clickedNode = this.tree;
                }
                return;
            }


            // Caso 2 : Se è stato specificato un path e il tree è stato costruito, path diventa il nodo selezionato
            if (isValid(path) /* && this.tree.path != ""*/) {
                this.clickedNode = this.tree.findNodeWithPath(path);
                if (this.clickedNode == null) {
                    this._setTreeAndClickedNode(path.getParent());
                    return;
                }
                return;
            }

            // Caso 3 : Se non è stato passato alcun path e bisogna costruire l'albero,
            //la root diventa il nome della piattaforma corrispondente a type e il nodo selezionato
            if (!isValid(path)) {
                this.tree = new ClientTreeNode("node", "", "" /*this.$ONEServiceTypeInfo[this.config.type].name*/, getRootType(this.config.type));
                this.clickedNode = this.tree;
                return;
            }

        },

        _setConfig(config) {
            this.config.type = config.type;
            this.config.limit = config.limit;
            this.config.client = config.client;

            this.config.rootPath = config.rootPath;

            this.config.tree = config.tree;

            this.config.includeFiles = config.includeFiles;

            this.config.isRootSelectable = config.isRootSelectable;
            this.exploreFSOptions.includeFiles = this.config.includeFiles;
        },

        //---------------------------------TAG INPUT------------------------------------------------------------------

        search() {
            if (this.clickedNode == null)
                return;

            this.filters.pathToSearch = this.filters.pathToSearch.validatePath(this.config.type, this.config.type.getSeparator());
            //Step 1 : Pulisco il percorso
            while (this.filters.pathToSearch.includes('"'))
                this.filters.pathToSearch = this.filters.pathToSearch.replace('"', "");
            this.filters.pathToSearch = this.filters.pathToSearch.trimEnd('\\').trimEnd('/');

            //Step 2 : Se è stato specificato un percorso ma corrisponde alla root di tree, non faccio nulla
            if (this.filters.pathToSearch != "" && this.filters.pathToSearch == this.config.rootPath)
                return;

            //Step 3: Se è stato cancellato il percorso da cercare ed era stato cercato un percorso
            // Si ricostruisce il tree di default
            if (this.filters.pathToSearch == "" && isValid(this.config.rootPath)) {
                this.config.rootPath = "";
                this.setSidebar(this.selectedNodes, this.config);
                return;
            }

            //Step 4: Se è stato cancellato un percorso ed era stata specificata una stringa da cercare
            // Si mostrano gli elementi nascosti
            if (this.filters.pathToSearch == "" && this.clickedNode != null) {
                this.clickedNode.children.forEach(node => $("#" + node.nodeID).removeClass("d-none"));
                return;
            }

            //Step 5: Se non è stato specificato un percorso, mostro solo i nodi in clickedNode che corrispondono a pathToSearch
            if (!this.filters.pathToSearch.includes("/") && !this.filters.pathToSearch.includes("\\") && this.clickedNode != null) {
                this.clickedNode.children.forEach(node => {
                    if (node.path.toLowerCase().split(node.path.getSeparator()).at(-1).startsWith(this.filters.pathToSearch.toLowerCase()))
                        $("#" + node.nodeID).removeClass("d-none");
                    else
                        $("#" + node.nodeID).addClass("d-none");
                });

                return;
            }

            //Step 6 : Se è stato specificato un percorso, imposto il tree partendo dal percorso cercato
            this.config.rootPath = this.filters.pathToSearch;
            this.setSidebar(this.selectedNodes, this.config);
        },

        async openCreateNewFolder(node) {
            var parentPath;
            var parentNode;
            if (node.isFile()) {
                parentPath = node.path.getParent();
                parentNode = this.tree.findNodeWithPath(parentPath);
            } else {
                parentPath = node.path;
                parentNode = node;
            }


            var mainFolders = [];

            if ([
                this.$ONEServiceType.FileFolder,
                this.$ONEServiceType.Cloud_AmazonS3Storage,
                this.$ONEServiceType.Cloud_S3CompatibleStorage,
                this.$ONEServiceType.Cloud_IperiusS3Storage,
                this.$ONEServiceType.Cloud_AzureBlob,
                this.$ONEServiceType.Cloud_AzureFile
            ].includes(this.config.type) && this.tree.children.every(n => n.path.endsWith(':\\') || n.nParts == 1))
                mainFolders = this.tree.children.map(n => n.path);
            var createFolderObj = {
                'parentPath': parentPath,
                'name': "",
                'client': this.config.client, // il tipo FileFolder non ha client
                'mainFolders': mainFolders
            };

            let self = this;
            this.$root.$on("createitemfeedback", newNodes => {
                if (newNodes == null) {
                    self.$root.$off("createitemfeedback")
                    return;
                }

                parentNode = null;
                newNodes.forEach(newNode => {
                    if (parentNode == null) {
                        parentNode = this.tree.findNodeWithPath(newNode.path.getParent());
                    }
                    newNode.nodeID = parentNode.nodeID + "-" + parentNode.children.length;
                    parentNode.children.push(newNode);
                    if (this.config.client != null && this.config.client.nodes)
                        this.config.client.nodes.push(newNode);
                    self.setChildrenToViewNode(parentNode.nodeID, [newNode], true, false);
                    parentNode = newNode;
                });

                self.setNode(newNodes.at(-1), true);

                //self.getNSetChildrenOfPath(path.getParent(), false);
                self.$root.$off("createitemfeedback")
            });

            this.$root.$emit("OPENCREATEFOLDERDIALOG", createFolderObj);
        }
    }
}